import React from "react";
import { TripDetail } from "../types";
import TripEmptyState from "../emptyState";
import {
  formatTripDateRange,
  getCertificationLabel,
} from "../utils";

const TripItinerary = ({ trip }: { trip: TripDetail }) => {
  const itinerary = trip.itinerary;
  const hasItinerary = Boolean(
    itinerary?.name || itinerary?.country || itinerary?.diversCount != null
  );
  const dateRange = formatTripDateRange(trip.fromDate, trip.toDate);
  const qualifications = trip.qualifications;
  const certLevels = qualifications?.certificationLevel || [];
  const hasQualifications =
    certLevels.length > 0 ||
    qualifications?.minLoggedDives != null ||
    Boolean(qualifications?.description);

  return (
    <section className="trip-section">
      <div className="trip-section-header">
        <h2 className="trip-section-title">Itinerary</h2>
      </div>

      {!hasItinerary && !dateRange && !hasQualifications ? (
        <TripEmptyState message="No itinerary data available" />
      ) : (
        <div className="trip-itinerary-content">
          {trip.tripImage ? (
            <div className="trip-itinerary-image-wrapper">
              <div
                className="trip-itinerary-image-bg"
                style={{
                  backgroundImage: `url(${trip.tripImage})`,
                }}
              />

              <img
                src={trip.tripImage}
                alt={itinerary?.name || "Trip"}
                className="trip-itinerary-image"
              />
            </div>
          ) : (
            <div className="trip-itinerary-image trip-hero-placeholder">
              <span>DiveBuddies</span>
            </div>
          )}

          {itinerary?.name ? (
            <h3 className="trip-itinerary-name">{itinerary.name}</h3>
          ) : null}

          <div className="trip-hero-meta">
            {itinerary?.country ? (
              <span className="trip-meta-chip">{itinerary.country}</span>
            ) : null}
            {dateRange ? (
              <span className="trip-meta-chip muted">{dateRange}</span>
            ) : null}
            {itinerary?.diversCount != null ? (
              <span className="trip-meta-chip muted">
                {itinerary.diversCount} diver
                {itinerary.diversCount === 1 ? "" : "s"}
              </span>
            ) : null}
            {trip.isPrivate != null ? (
              <span className="trip-meta-chip muted">
                {trip.isPrivate ? "Private" : "Public"}
              </span>
            ) : null}
            {trip.tripId ? (
              <span className="trip-meta-chip muted">{trip.tripId}</span>
            ) : null}
          </div>

          {hasQualifications ? (
            <div className="trip-itinerary-requirements">
              <h4 className="trip-subsection-title">Requirements</h4>
              {certLevels.length > 0 ? (
                <div className="trip-chip-row">
                  {certLevels.map((level) => (
                    <span key={level} className="trip-tag">
                      {getCertificationLabel(level)}
                    </span>
                  ))}
                </div>
              ) : null}
              {qualifications?.minLoggedDives != null ? (
                <p className="trip-section-text">
                  Min. logged dives:{" "}
                  <strong>{qualifications.minLoggedDives}</strong>
                </p>
              ) : null}
              {qualifications?.description ? (
                <p className="trip-section-text">
                  {qualifications.description}
                </p>
              ) : null}
            </div>
          ) : null}
        </div>
      )}
    </section>
  );
};

export default TripItinerary;
